import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPage from '../views/DashboardPage.vue'
import TreatmentReferencePage from '../views/Treatments/TreatmentReferencePage.vue'
import MedicineReferencePage from '../views/Medicines/MedicineReferencePage.vue'
import MyTreatmentsPage from '../views/Treatments/MyTreatmentsPage.vue'
import CommunityTreatmentsPage from '../views/Treatments/CommunityTreatmentsPage.vue'
import DentalArticlePage from '../views/Articles/DentalArticlePage.vue'
import LoginPage from '../views/Login/LoginPage.vue'
import LoadingScreen from '../views/LoadingScreen.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/loginPage',
    name: 'LoginPage',
    component: LoginPage
  },
  { 
    path: '/dashboardPage',
    name: 'DashboardPage',
    component: DashboardPage,
    props: true
  },
  {
    path: '/treatmentReferencePage',
    name: 'TreatmentReferencePage',
    component: TreatmentReferencePage,
    props: true
  },
  {
    path: '/medicineReferencePage',
    name: 'MedicineReferencePage',
    component: MedicineReferencePage,
    props: true
  },
  {
    path: '/myTreatmentsPage',
    name: 'MyTreatmentsPage',
    component: MyTreatmentsPage,
    props: true
  },
  {
    path: '/communityTreatmentsPage',
    name: 'CommunityTreatmentsPage',
    component: CommunityTreatmentsPage,
    props: true
  },
  {
    path: '/dentalArticlePage',
    name: 'DentalArticlePage',
    component: DentalArticlePage,
    props: true
  },
  {
    path: '/loadingScreen',
    name: 'LoadingScreen',
    component: LoadingScreen,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.replace({ path: '/loginPage', redirect: '/' })

router.beforeEach((to, from, next) => {
  // Should add in an authentication check here when going to LoadingScreen, if not authenticated return back to our safety route (LoginScreen)

  // Navigation Guard to prevent the ability to go back to the loading screen
  if (to.name === "LoadingScreen" && from.name !== "LoginPage") next(false)
  else next();

  // // Navigation Guard to prevent navigating to the same page
  // if (to.name === from.name) next (false)
  // else next();
})


export default router
